// ONE WEB SOURCE in an AI answer (U4; functions/assistantSources.js): a real
// link to its page, opened in a new tab — the title (wraps, never cut), the
// domain in the house micro-label, the snippet. The home kit's quiet row
// wash under the pointer; the global focus ring.
export const AssistantSourceCard = {
  extends: 'Link',
  dataSourceCard: true,
  href: (el, s) => (s && s.url) || null,
  target: '_blank',
  rel: 'noopener noreferrer',
  flow: 'y',
  gap: 'Y',
  padding: 'A',
  minWidth: '0',
  maxWidth: '100%',
  boxSizing: 'border-box',
  round: 'radiusCard',
  theme: 'layer',
  color: 'title',
  textDecoration: 'none',
  ':hover': { background: 'hover' },
  ':active': { background: 'selected' },
  SourceMeta: {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    minWidth: '0',
    color: 'caption',
    AppMicroLabel: {
      color: 'caption',
      minWidth: '0',
      whiteSpace: 'normal',
      overflowWrap: 'anywhere',
      text: (el, s) => (s && s.domain) || ''
    },
    Icon: {
      name: 'arrowUpRight',
      ariaHidden: true,
      boxSize: 'Z',
      flexShrink: '0'
    }
  },
  SourceTitle: {
    tag: 'span',
    fontSize: 'Z2',
    fontWeight: '500',
    lineHeight: '1.45',
    overflowWrap: 'anywhere',
    text: (el, s) => (s && s.title) || ''
  },
  SourceSnippet: {
    tag: 'span',
    fontSize: 'Z1',
    fontWeight: '400',
    lineHeight: '1.5',
    color: 'caption',
    overflowWrap: 'anywhere',
    hide: (el, s) => !(s && s.snippet),
    text: (el, s) => (s && s.snippet) || ''
  }
}
